export default __webpack_public_path__ + "static/media/2-mobile+hor.a6b9c5e6.jpg";